import React from 'react';
import { FormattedMessage } from 'react-intl';
import _get from 'lodash.get';
import dayJS from 'dayjs';

import { Locales } from '@ratehub/base-ui';


function getPenaltyCalculations({
    locale,
    balanceName = 'currentBalance',
    rateName = 'currentRate',
    originalTermName = 'originalTerm',
    startDateName = 'startDate',
    finalFeeName = 'calculatedPenaltyFee',
    irdFactorName = 'irdFactor',
}) {
    const irdTooltipLink = locale === Locales.FRENCH
        ? '/refinancement-hypothecaire-penalite'
        : '/mortgage-refinance-penalty';

    return {
        balanceCalculation: {
            id: 'balanceCalculation',
            name: 'balanceCalculation',
            label: (
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.balanceCalculation"
                    defaultMessage="Outstanding mortgage balance"
                />
            ),
            operandValue: balanceName,
        },
        irdFactorCalculation: {
            id: 'irdFactorCalculation',
            name: 'irdFactorCalculation',
            label: (
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.irdFactorCalculation"
                    defaultMessage="IRD factor"
                />
            ),
            tooltipMessage:(
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.irdFactorCalculationTooltip"
                    defaultMessage={'IRD (<irdDefinitionLink>interest rate differential</irdDefinitionLink>) is a fee compensating lenders for the interest they lose by breaking your mortgage early.'}
                    values={{
                        irdDefinitionLink: str => (
                            <a
                                href={irdTooltipLink}
                                target="_blank"
                            >
                                {str}
                            </a>
                        ),
                    }}
                />
            ),
            tooltipWidth: '17em',
            operandValue: irdFactorName,
            operandFormat: 'decimal4',
            operator: 'times',
        },
        monthsRemainingCalculation: {
            id: 'monthsRemainingCalculation',
            name: 'monthsRemainingCalculation',
            label: (
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.monthsRemainingCalculation"
                    defaultMessage="Months remaining in term"
                />
            ),
            operandValue: (values) => getMonthsRemaining(
                _get(values, originalTermName),
                _get(values, startDateName),
            ),
            operandFormat: 'decimal0',
            operator: 'times',
        },
        rateCalculation: {
            id: 'rateCalculation',
            name: 'rateCalculation',
            label: (
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.rateCalculation"
                    defaultMessage="Current mortgage rate"
                />
            ),
            operandValue: (values) => _get(values, rateName) / 100,
            operandFormat: 'percent2',
            operator: 'times',
        },
        threeMonthsFactorCalculation: {
            id: 'threeMonthsFactorCalculation',
            name: 'threeMonthsFactorCalculation',
            label: (
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.threeMonthsFactorCalculation"
                    defaultMessage="Three month’s interest"
                />
            ),
            operandValue: 0.25,
            operandFormat: 'decimal2',
            operator: 'times',
        },
        finalPenaltyFeeCalculation: {
            id: 'finalPenaltyFeeCalculation',
            name: 'finalPenaltyFeeCalculation',
            label: (
                <FormattedMessage
                    id="mtg-calculators.formulasPenalty.finalPenaltyFeeCalculation"
                    defaultMessage="Mortgage break penalty"
                />
            ),
            operandValue: finalFeeName,
            operator: 'equals',
            result: true,
        },
    };
}

function getMonthsRemaining(originalTerm, startDate) {
    const currentDate = dayJS();
    const monthsElapsed = currentDate.diff(startDate, 'month');
    const monthsRemaining = (originalTerm * 12) - monthsElapsed;

    return monthsRemaining;
}

export default getPenaltyCalculations;
